module.exports = __webpack_public_path__ + "static/media/container.ea6daa1b.svg";